import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import type { ReactElement } from "react";
import { MdaiAccordion, type MdaiAccordionItemProps } from "./MdaiAccordion";

export interface AccordionSectionProps {
  title?: string;
  subtitle?: string;
  overline?: string;
  description?: string | ReactElement;
  items?: MdaiAccordionItemProps[];
}

export function AccordionSection({
  title,
  subtitle,
  overline,
  description,
  items,
}: AccordionSectionProps) {
  return (
    <Stack direction={{ sm: "column", lg: "row" }} gap={4} width="100%">
      <Box
        sx={{
          alignSelf: {
            sm: "center",
            lg: "flex-start",
          },
          height: "100%",
          width: "100%",
          maxWidth: { md: 600, lg: 450 },
          order: { lg: 0 },
        }}
      >
        <Typography display="block" mb={1} variant="overline">
          {overline}
        </Typography>

        {title && (
          <Typography mb={subtitle ? 2 : 4} variant="h3">
            {title}
          </Typography>
        )}

        {subtitle && (
          <Typography mb={4} variant="subtitle1">
            {subtitle}
          </Typography>
        )}

        {description &&
          (description instanceof String ? (
            <Typography mb={4}>{description}</Typography>
          ) : (
            description
          ))}
      </Box>
      <Stack
        gap={{ sm: 3, lg: 2 }}
        sx={{
          alignSelf: { sm: "center", lg: "flex-end" },
          maxWidth: { lg: "100%" },
        }}
        textAlign={{ sm: "center", lg: "left" }}
      >
        <MdaiAccordion align="flex-start" items={items ?? []} />
      </Stack>
    </Stack>
  );
}
